import { render, staticRenderFns } from "./DocumentUploadOther.vue?vue&type=template&id=6582666d&scoped=true&"
import script from "./DocumentUploadOther.vue?vue&type=script&lang=js&"
export * from "./DocumentUploadOther.vue?vue&type=script&lang=js&"
import style0 from "./DocumentUploadOther.vue?vue&type=style&index=0&id=6582666d&prod&lang=css&"
import style1 from "./DocumentUploadOther.vue?vue&type=style&index=1&id=6582666d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6582666d",
  null
  
)

export default component.exports